import { REDPLUS_KIDS_GROUP, SalesChannel, SALESCHANNEL_SOHO } from '@vfde-fe/sails-constants';

/**
 * SOHO and RED+ are not eligible for trade-in, return false if it's the case
 * @param subscriptionId
 * @param salesChannel
 */
export const getIsTradeInEligible = (subscriptionId: string | null, salesChannel: SalesChannel | null): boolean => {
    return (salesChannel !== SALESCHANNEL_SOHO) && subscriptionId !== `${REDPLUS_KIDS_GROUP}`;
};
